import asyncAction from '../asyncAction';

const FETCH_USER = asyncAction('FETCH_USER');
const INITIAL_FETCH_USER = asyncAction('INITIAL_FETCH_USER');

const FETCH_USERS = asyncAction('FETCH_USERS');
const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
const SET_MSAL_INSTANCE = 'SET_MSAL_INSTANCE';
const SET_MSAL_ACCOUNT = 'SET_MSAL_ACCOUNT';

export {
  FETCH_USER,
  INITIAL_FETCH_USER,
  FETCH_USERS,
  SET_ACCESS_TOKEN,
  SET_MSAL_INSTANCE,
  SET_MSAL_ACCOUNT,
};
